import { outsightService as service } from '@/service';
import { getNonce } from '@/common/utils';
import sg from '@/common/storage';
// import { gappService as gapp } from '@/service';
// console.log(gapp);
let temp_id = sg.getStorage('uuid') || '';
let temp_id_val = getNonce(16) + new Date().getTime();
if (!temp_id) {
  sg.setStorage('uuid', temp_id_val);
}
function post(path, data, opts) {
  data.temp_id = temp_id || temp_id_val;
  return service.post(path, data, opts);
}

export function postForm(url, params = {}, opts) {
  let fd = new FormData();
  params.temp_id = temp_id || temp_id_val;
  Object.keys(params).forEach(key => {
    fd.append(key, params[key]);
  });
  return post(url, fd, opts);
}

// function get(path, params) {
//   return service.get(path, { params });
// }

//微信分享参数接口
export function wxconfig(data) {
  return post('/v1/api/activity/fission/wxsign', data);
}

//微信分享成功通知接口
export function shareReport(data) {
  return post('/v1/api/activity/fission/share', data);
}

//活动开始获取角色、队友信息
export function initData(data) {
  return post('/v1/api/activity/fission/init', data);
}

//获取事件信息
export function eventData(data) {
  return post('/v1/api/activity/fission/event', data);
}

//获取结局
export function resultData(data) {
  return post('/v1/api/activity/fission/result', data);
}
